import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { useState } from "react";
const TitleActionMobile = ({
  title,
  handleDelete,
  sub,
  index,
  handleup,
  handledown,
  handleEdit,
  children,
  icon
}) => {
  const [active, setActive] = useState(false);
  return (
    <div className="col-12 ">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div
            onClick={() => setActive(!active)}
            style={{
              border: "2px solid black",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "30px",
              width: "30px",
              borderRadius: "1000px",
              cursor: "pointer",
            }}
          >
            {active ? (
              <ArrowDropUpIcon></ArrowDropUpIcon>
            ) : (
              <ArrowDropDownIcon />
            )}
          </div>{" "}
          
            {icon}
          <div
            style={{
              display: "flex",
              fontWeight: "bold",
            }}
          >
            <div
              className="datatite"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
              dangerouslySetInnerHTML={{
                __html: title,
              }}
            />
          </div>{" "}
        </div>{" "}
        <div
          style={{
            display: "flex",
            fontWeight: "bold",
          }}
        >
          {handleup && (
            <div
              style={{
                display: "flex",
                alignItems: "center",

                marginRight: "10px",
              }}
            >
              <div
                style={{
                  cursor: "pointer",
                  color: "#9f9f9f",
                  marginLeft: "20px",
                }}
                onClick={() => handleup(index)}
              >
                <ArrowCircleUpIcon style={{ color: "red", fontSize: 28 }} />
              </div>
              <div
                style={{
                  cursor: "pointer",
                  color: "#9f9f9f",
                  marginRight: "20px",
                }}
                onClick={() => handledown(index)}
              >
                <ArrowCircleDownIcon style={{ color: "green", fontSize: 28 }} />
              </div>
            </div>
          )}
        </div>
      </div>{" "}
      {active && <div style={{ marginTop: "10px" }}>{active && children} </div>}
    </div>
  );
};

export default TitleActionMobile;
